import { render, staticRenderFns } from "./PenaltyBonus.vue?vue&type=template&id=71e79226&scoped=true"
import script from "./PenaltyBonus.vue?vue&type=script&lang=js"
export * from "./PenaltyBonus.vue?vue&type=script&lang=js"
import style0 from "./PenaltyBonus.vue?vue&type=style&index=0&id=71e79226&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "71e79226",
  null
  
)

export default component.exports